/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useToast } from "../../../basecomp/components/provider/ToastProvider";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CameraAltIcon from "@mui/icons-material/AddAPhoto";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import AddBoxIcon from "@mui/icons-material/AddBox";
import PreviewIcon from "@mui/icons-material/Preview";
import CButton from "../../../basecomp/components/CButton2";
import {
  fetchSizeOptions,
  fetchStickers,
  fetchPoOrMaterial,
  addSticker,
  updateSticker,
  deleteSticker,
  getStickerPdf,
  addAllSticker,
  fetchSlocOptions,
  changePreference,
} from "../model/PrintingModel";
import { AddPrintKeys, PrintViewTypes } from "../../assets/VarConstants";
import { gblNameOrLocalNameCheck, ImageUpload } from "../../../image_upload/src/model/ImageUpload";
import { ImageRequired, imageSize, MaterialNumberRequired, MaxImageSelect, MaxImageUpload, maxSizePerFile } from "../../../image_upload/assets/Strings";
import { LibraryAdd, PlaylistAddCircleOutlined } from "@mui/icons-material";

const PrintingVM = () => {
  const navigate = useNavigate();
  const { handleToastOpen } = useToast();
  const { t } = useTranslation();
  const [isPrinting, setIsPrinting] = useState(false)
  const [poOptions, setPoOptions] = useState([]);
  const [matOptions, setMatOptions] = useState([]);
  const [sizeOptions, setSizeOptions] = useState([]);
  const [sLocOptions, setSLocOptions] = useState([]);
  const [stickerData, setStickerData] = useState({
    [AddPrintKeys.PO_KEY]: "",
    [AddPrintKeys.MAT_NO_KEY]: "",
    [AddPrintKeys.SIZE_KEY]: "",
    [AddPrintKeys.QUANTITY_KEY]: 1,
    [AddPrintKeys.STORAGE_LOC_KEY]: "",
  });
  const [selectedSize, setSelectedSize] = useState();
  const [selectedSLoc, setSelectedSLoc] = useState();
  let isTableEdit = false;
  const [buttonJson, setButtonJson] = useState({
    add: {
      text: "Add",
      tooltipText: "Add",
      isDisabled: false,
      src: <AddBoxIcon />,
    },
    add_all: {
      text: "Add All",
      tooltipText: "Add All",
      isDisabled: false,
      src: <LibraryAdd />,
    },
    print: {
      text: "Print",
      tooltipText: "Print",
      isDisabled: false,
      src: <LocalPrintshopIcon />,
    },
    view: {
      text: "View",
      tooltipText: "View",
      isDisabled: false,
      src: <PictureAsPdfIcon />,
    },
  });
  const [openCarousel, setOpenCarousel] = useState(false);
  const [labelData, setLabelData] = useState([]);
  const [carouselImages, setCarouselImages] = useState([]);
  const [globalType, setGlobalType] = useState("");

  const [forceInput, setForceInput] = useState(false);
  let tableStickerDataGlobal = {};

  const fetchAllStickers = async () => {
    try {
      const response = await fetchStickers();
      const updatedStickers = response.data.map((obj) => ({
        ...obj,
        tableMode: "T",
      }));
      setLabelData(updatedStickers);
    } catch (error) {
      setLabelData([]);
    }
  };

  useEffect(() => {
    if (stickerData[AddPrintKeys.PO_KEY] !== "") {
      handlePOEdit(stickerData[AddPrintKeys.PO_KEY]);
    }
  }, [stickerData[AddPrintKeys.PO_KEY]]);

  useEffect(() => {
    if (stickerData[AddPrintKeys.MAT_NO_KEY] !== "") {
      handleMaterialEdit(stickerData[AddPrintKeys.MAT_NO_KEY]);
    }
  }, [stickerData[AddPrintKeys.MAT_NO_KEY]]);

  useEffect(() => {
    const fetchSize = async () => {
      try {
        const response = await fetchSizeOptions();
        setSizeOptions(response.data);
        if (response.data.length === 1) {
        }
      } catch (error) {
        handleToastOpen("error", error.message);
        setSizeOptions([]);
      }
    };
    const fetchSloc = async () => {
      try {
        const response = await fetchSlocOptions();
        setSLocOptions(response.data.options);
        console.log("logging selected value");
        console.log(response.data.storage_loc);
        if(response.data.storage_loc){
          setSelectedSLoc(response.data.storage_loc)
          handleStickerDataEdit(AddPrintKeys.STORAGE_LOC_KEY)(response.data.storage_loc)
        }
        if (response.data.length === 1) {
        }
      } catch (error) {
        handleToastOpen("error", error.message);
        setSLocOptions([]);
      }
    };
    fetchSize();
    fetchSloc()
    fetchAllStickers();
  }, []);

  const handleEditClick = async (data, index) => {
    console.log("labelData[index]  ", tableStickerDataGlobal, index);
    if (data.tableMode === "E") {
      try {
        const response = await updateSticker(
          tableStickerDataGlobal.id,
          tableStickerDataGlobal.material_no,
          tableStickerDataGlobal.bin_location === null
            ? ""
            : tableStickerDataGlobal.bin_location,
          tableStickerDataGlobal.bulk_location === null
            ? ""
            : tableStickerDataGlobal.bulk_location,
          tableStickerDataGlobal.print_qty
        );
        const updatedData = response.data;
        isTableEdit = false;
        setLabelData((prevLabelData) => {
          const updatedLabelData = [...prevLabelData];
          updatedLabelData[index].tableMode = "T";
          updatedLabelData[index].material_no = updatedData.material_no;
          updatedLabelData[index].material_status = updatedData.material_status;
          updatedLabelData[index].bin_location = updatedData.bin_location;
          updatedLabelData[index].bin_loc_status = updatedData.bin_loc_status;
          updatedLabelData[index].bulk_location = updatedData.bulk_location;
          updatedLabelData[index].print_qty = updatedData.print_qty;
          return updatedLabelData;
        });
        await fetchAllStickers();
      } catch (error) {
        handleToastOpen("error", error.message);
      }
    } else {
      if (isTableEdit === false) {
        isTableEdit = true;
        const updatedLabelData = { ...data };
        updatedLabelData.tableMode = "E";
        tableStickerDataGlobal = updatedLabelData;
        setLabelData((prevLabelData) => {
          const updatedLabelData = [...prevLabelData];
          updatedLabelData[index].tableMode = "E";
          return updatedLabelData;
        });
      }
    }
  };

  const handlePOEdit = async (value) => {
    try {
      if (value === ""|| value === null) {
        setPoOptions([]);
        setMatOptions([]);
          setStickerData((prevStickerData) => ({
        ...prevStickerData,
        [AddPrintKeys.MAT_NO_KEY]: "",
      }));
      } else if (stickerData[AddPrintKeys.MAT_NO_KEY] === "" || stickerData[AddPrintKeys.MAT_NO_KEY] === null) {
        const response = await fetchPoOrMaterial(value, "");
        setMatOptions(response.data);
      }
    } catch (error) {
      handleToastOpen("error", error.message);
    }
  };

  const handleMaterialEdit = async (value,type) => {
    try {
      if (value === "" || value === null) {
        setPoOptions([]);
        setMatOptions([]);
        setStickerData((prevStickerData) => ({
        ...prevStickerData,
        [AddPrintKeys.PO_KEY]: "",
      }));
      } else if (stickerData[AddPrintKeys.PO_KEY] === "" && type==="input") {
        const response = await fetchPoOrMaterial("", value);
        setPoOptions(response.data);
      }
      
    } catch (error) {
      // handleToastOpen("error", error.message);
    }
  };

  const handleStickerDataEdit = (key) => (value,type) => {
    setStickerData((prevStickerData) => ({
      ...prevStickerData,
      [key]: typeof value === "string" && value !== null ? value.trim() : value,
    }));

    if (key === AddPrintKeys.MAT_NO_KEY) {
      handleMaterialEdit(value,type);
      if(type ==="input"){
      setStickerData((prevStickerData) => ({
        ...prevStickerData,
        [AddPrintKeys.PO_KEY]: "",
      }));
    }
      setPoOptions([]);
      setForceInput(false)
    } else if (key === AddPrintKeys.PO_KEY) {
      handlePOEdit(value);
      setMatOptions([])
      if(type ==="input"){
      setStickerData((prevStickerData) => ({
        ...prevStickerData,
        [AddPrintKeys.MAT_NO_KEY]: "",
      }));
    }
    }
  };

  const handleTableEditClick = (key) => (value) => {
    tableStickerDataGlobal[key] = value;
  };

  const handleSizeChange = (value) => {
    console.log("printing size");
    console.log(value);
    if (value === null || value === "") {
      handleStickerDataEdit(AddPrintKeys.SIZE_KEY)("");
    } else {
      handleStickerDataEdit(AddPrintKeys.SIZE_KEY)(value.id);
    }
  };
  const handleStorageLocationChange = (value) => {
    console.log('WE ARE PRINTING VALUE');
    console.log(value);
    if (value === null || value === "") {
      handleStickerDataEdit(AddPrintKeys.STORAGE_LOC_KEY)("");
    } else {
      handleStickerDataEdit(AddPrintKeys.STORAGE_LOC_KEY)(value);
      changePreferenceFunc("storage_loc",value)
    }
  };

   const changePreferenceFunc=async (type,value)=>{
    try{
    let response = await changePreference(type,value);
    }
    catch(error){
      console.log("error occoured in changing preference");
      console.log(error.response);
    }
    
  }

  const validateStickers = () => {
    console.log("printing");
    console.log(stickerData[AddPrintKeys.STORAGE_LOC_KEY]);
    if (
      stickerData[AddPrintKeys.MAT_NO_KEY] === "" ||
      stickerData[AddPrintKeys.SIZE_KEY] === "" ||
      stickerData[AddPrintKeys.QUANTITY_KEY] === ""||
      stickerData[AddPrintKeys.STORAGE_LOC_KEY] === ""
    ) {
      handleToastOpen("error", "Please enter the required fields");
      return false;
    }

    return true;
  };

  const addStickerData = async () => {
    try {
      if (
        stickerData[AddPrintKeys.QUANTITY_KEY] > 500 ||
        stickerData[AddPrintKeys.QUANTITY_KEY] <= 0
      ) {
        handleToastOpen("error", "Quantity should be in between 1-500");
        return false;
      }
      const response = await addSticker(stickerData);
      handleToastOpen("success", response.data.message);
      await fetchAllStickers();
    } catch (error) {
      handleToastOpen("error", error.message);
    }
  };
  const addAllStickerData = async () => {
    try {
      const response = await addAllSticker(stickerData[AddPrintKeys.SIZE_KEY], stickerData[AddPrintKeys.PO_KEY],stickerData[AddPrintKeys.STORAGE_LOC_KEY]);
      console.log(response);
      handleToastOpen("success", response.data);
      await fetchAllStickers();
    } catch (error) {
      handleToastOpen("error", error.message);
    }
  };

  const deleteStickerData = async (id) => {
    try {
      const response = await deleteSticker(id);
      handleToastOpen("success", response.data.message);
      isTableEdit = false;
      tableStickerDataGlobal = {};
      await fetchAllStickers();
    } catch (error) {
      handleToastOpen("error", error.message);
    }
  };

  const getFormattedDateTime = () => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    const currentTime = currentDate.toLocaleTimeString();
    return formattedDate + "_" + currentTime;
  };

  const pdfPrintView = async (id, stickerData, isPrint, type) => {
    try {
      setIsPrinting(true)
      const response = await getStickerPdf(id, stickerData, type, isPrint);
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      if (isPrint) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `label_list_${getFormattedDateTime()}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } else {
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      }
      setIsPrinting(false)
    } catch (error) {
      setIsPrinting(false)
      handleToastOpen("error", error.message);
    }
  };

  const handelUserTyping = () => {
    setForceInput(true)
    setMatOptions([])
    setStickerData((prevStickerData) => ({
      ...prevStickerData,
      [AddPrintKeys.MAT_NO_KEY]: "",
    }));
  }

  const handleButtonClick = (key) => {
    if (key === "add_all") {
      // const isValidated = validateStickers();
      if ( stickerData[AddPrintKeys.SIZE_KEY] !== "" && stickerData[AddPrintKeys.PO_KEY] !== "" && stickerData[AddPrintKeys.STORAGE_LOC_KEY] !== "") {
        addAllStickerData();
        console.log("helo bhai ");
      }
      else{
        handleToastOpen("error", "Either size , purchase order or storage_location is missing");
      }
    } 
    else if (key === "add") { 
      const isValidated = validateStickers();
      if (isValidated) {
        addStickerData();
      }
    } 
    else if (key === "delete_all") {
      deleteStickerData();
    } else if (key === "print") {
      const isValidated = validateStickers();
      if (isValidated) {
        pdfPrintView(
          undefined,
          stickerData,
          true,
          PrintViewTypes.PRINT_VIEW_DATA
        );
      }
    } else if (key === "view") {
      const isValidated = validateStickers();
      if (isValidated) {
        pdfPrintView(
          undefined,
          stickerData,
          false,
          PrintViewTypes.PRINT_VIEW_DATA
        );
      }
    } else if (key === "print_all") {
      pdfPrintView(undefined, undefined, true, PrintViewTypes.PRINT_VIEW_ALL);
    }
  };

  const handelImageUpload = async (materialReq,selectedImages,) => {
    if (!materialReq) {
      handleToastOpen("error", MaterialNumberRequired);
      return;
    }
    if (!selectedImages || selectedImages.length === 0) {
      handleToastOpen("error", ImageRequired);
      return;
    }
    if (selectedImages.length > 5) {
      handleToastOpen("error", MaxImageSelect);
      return;
    }
    if (selectedImages.length > 5) {
      handleToastOpen("error", MaxImageUpload);
      return;
    }
    // Validate each image size and total size
    let totalSize = 0;

    for (const image of selectedImages) {
      totalSize += image.size;

      if (image.size > maxSizePerFile) {
        handleToastOpen("error", imageSize);
        return;
      }
    }
    setIsPrinting(true);
    const email = localStorage.getItem("email");
    const response = await gblNameOrLocalNameCheck(email);
    setGlobalType(response.data.is_global);
    try {
      await ImageUpload(
        materialReq,
        response.data.is_global,
        selectedImages,
        handleToastOpen
      );
    }
    catch (error) {
      console.log("we are in error",error);
    } finally {
      setIsPrinting(false); // Set loading to false after completion
    }
  }

  const handleImageClick = async (actualRow,images) => {
    const hasNoImages = actualRow.image_link.length === 0;
    console.log("hasNoImages:  ", hasNoImages, actualRow, actualRow.image_link);
    if (hasNoImages) {
      // navigate(`/warehouse/image-upload?mat_no=${actualRow.material_no}`);
      console.log("we are in the images in printing vm ");
      console.log(images);

      await handelImageUpload(actualRow.material_no,images)
      await fetchAllStickers();


    } else {
      setCarouselImages(actualRow.image_link);
      setOpenCarousel(true);
    }
  };

  const infoHeadData = [
    t("material_number"),
    t("material_desc"),
    t("p_qty"),
    t("imgs"),
    t("bin_loc"),
    t("bulk_loc"),
    t("Edit"),
    <CButton
      cSrc={<DeleteIcon />}
      cTooltipText="DeleteAll"
      cOnClick={() => handleButtonClick("delete_all")}
    />,
    t("preview"),
    <CButton
      cSrc={<LocalPrintshopIcon />}
      cTooltipText="PrintAll"
      cOnClick={() => handleButtonClick("print_all")}
    />,
  ];

  const [infoRowData, setInfoRowData] = useState([
    {
      value: `material_no`,
      tooltipText: (actualRow) =>
        actualRow.material_status === 0
          ? "MaterialPresent"
          : "MaterialNotPresent",
      status: `material_status`,
      type: "M",
      actualType: (actualRow) => actualRow.tableMode,
      actionV: (value) => handleTableEditClick(AddPrintKeys.MAT_NO_KEY)(value),
    },
    {
      value: `material_desc`,
      type: "T",
      status: `material_status`,
    },
    {
      value: `print_qty`,
      status: `material_status`,
      type: "M",
      eType: "quantity",
      actualType: (actualRow) => actualRow.tableMode,
      actionV: (value) =>
        handleTableEditClick(AddPrintKeys.QUANTITY_KEY)(value),
    },
    {
      value: (actualRow) =>
        actualRow.image_link.length === 0 ? <CameraAltIcon /> : <PreviewIcon />,
      tooltipText: (actualRow) =>
        actualRow.image_link.length === 0 ? "ImageUpload" : "ImageView",
      type: "IU",
      hasImage:(actualRow) =>
        actualRow.image_link.length === 0 ? false : true,
      actionV: (actualRow,images) => handleImageClick(actualRow,images),
    },
    {
      value: `bin_location`,
      status: `material_status`,
      tooltipText: (actualRow) =>
      // actualRow.sap_bin_status === 0 ? "BinPresent" : "BinNotPresent",
      {
        if (actualRow.other_materials_in_bin_flag == 1) {
          return actualRow.sap_bin_status === 0 ? "BinPresentDuplicate" : "BinNotPresentDuplicate"
        } else {
          return actualRow.sap_bin_status === 0 ? "BinPresent" : "BinNotPresent"

        }
      },
      type: "M",
      actualType: (actualRow) =>
        actualRow.bin_loc_status === 1 ? "T" : actualRow.tableMode,
      actionV: (value) => handleTableEditClick(AddPrintKeys.BIN_LOC_KEY)(value),
    },
    {
      value: `bulk_location`,
      status: `material_status`,
      type: "M",
      actualType: (actualRow) => actualRow.tableMode,
      actionV: (value) =>
        handleTableEditClick(AddPrintKeys.BULK_LOC_KEY)(value),
    },
    {
      value: (actualRow) =>
        actualRow.tableMode === "T" ? <EditIcon /> : <SaveIcon />,
      tooltipText: (actualRow) =>
        actualRow.tableMode === "T" ? t("Edit") : t("Save"),
      type: "IC",
      actionV: (actualRow, index) => handleEditClick(actualRow, index),
    },
    {
      value: <DeleteIcon />,
      tooltipText: "Delete",
      type: "I",
      actionV: (actualRow) => deleteStickerData(actualRow.id),
    },
    {
      value: <PictureAsPdfIcon />,
      tooltipText: "View",
      status: `material_status`,
      type: "I",
      actionV: (actualRow) =>
        pdfPrintView(
          actualRow.id,
          undefined,
          false,
          PrintViewTypes.PRINT_VIEW_ID
        ),
    },
    {
      value: <LocalPrintshopIcon />,
      tooltipText: "Print",
      status: `material_status`,
      type: "I",
      actionV: (actualRow) =>
        pdfPrintView(
          actualRow.id,
          undefined,
          true,
          PrintViewTypes.PRINT_VIEW_ID
        ),
    },
  ]);

  return {
    poOptions,
    matOptions,
    sizeOptions,
    sLocOptions,
    selectedSize,
    selectedSLoc,
    stickerData,
    handleStickerDataEdit,
    buttonJson,
    labelData,
    handleSizeChange,
    handleStorageLocationChange,
    handleButtonClick,
    infoHeadData,
    infoRowData,
    carouselImages,
    openCarousel,
    setOpenCarousel,
    isPrinting,
    setForceInput,
    forceInput,
    handelUserTyping,
  };
};

export default PrintingVM;
